/**
 * : 商品日志
 */
import { generate } from '@/utils/request';
const config = {
  prefix: '/sgoo/v1/{organizationId}',
  items: [
    // 操作日志
    { key: 'getLogPage', url: '/operate-logs', method: 'GET' },
  ],
};

export default {
  ...generate(config),
};
